import React from 'react';
import styles from './settings.module.css';
import { Tabs, Typography } from 'antd';
import { useSelector } from 'react-redux';
import MyProfile from './components/my-profile/my-profile';
import MyInstitution from './components/my-institution/my-institution';
import ChangePassword from './components/change-password/change-password';

const Settings = () => {
  const user = useSelector((state) => state.user?.user); 
  const items = [
    {
      key: "1",
      label: "My Profile",
      children: <MyProfile />,
    },
    {
      key: "2",
      label: "My Institution",
      children: <MyInstitution />,
    },
    {
      key: "3",
      label: "Security",
      children: <ChangePassword />,
    },
  ];

  return user?.role === 'ADMIN' ? (
    <div>
      <Typography className={styles.settingsTitle}>
        Settings
      </Typography>
      <div className={styles.settingsTabs}>
        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarStyle={{ borderBottom: "none" }}
          destroyInactiveTabPane
        />
      </div>
    </div>
  ) : (
    <div className={styles.comingSoonWrapper}>
      <div className={styles.comingSoonCard}>
        <h1 className={styles.title}>Coming Soon</h1>
        <p className={styles.subtitle}>
          Our website is under construction. We'll be here soon with our new
          awesome site.
        </p>
      </div>
    </div>
  );
};

export default Settings;
